import * as React from 'react'
import { FC } from 'react'
import Typography from '@mui/material/Typography'

import { Channel } from 'shared/types'
import EmailChannelType from './types/EmailChannel'
import SlackChannelType from './types/SlackChannel'
import { channelLookup } from './types'
import { useRecordContext } from 'react-admin'

type ConfigEditInputsProps = {
  formData?: Channel
  source?: string
  fullWidth?: boolean
  showTitle?: boolean
  disabled?: boolean
}

export const ConfigEditInputs: FC<ConfigEditInputsProps> = ({
  showTitle = true,
  disabled = false,
  formData,
  ...rest
}) => {
  const record = formData || useRecordContext()
  if (!record?.type) return null

  const type = channelLookup[record.type]
  const Inputs = type?.Inputs || null

  if (type.summaryFor(record).includes('Type')) {
    disabled = true
  }

  return (
    <>
      {/* {showTitle && (
        <Typography variant="h5" component="h1">
          {type.summaryFor(record)}
        </Typography>
      )} */}
      <Inputs disabled={disabled} {...rest} />
    </>
  )
}
